var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagWales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.2705C32 25.107 24.8365 32.2705 16 32.2705C7.1635 32.2705 0 25.107 0 16.2705",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6884 11.4042C27.1162 9.78154 25.5701 8.61816 23.7517 8.61816H20.1739C17.8687 8.61816 16 10.4869 16 12.7921C16 13.5452 16.2005 14.269 16.5494 14.879C15.2209 14.8682 13.9913 14.8882 13.2174 14.879C13.2174 13.2693 13.2174 11.2187 13.2174 10.7896L13.3817 10.6252C14.1196 9.88735 13.8736 8.6576 13.8736 8.6576C13.8736 8.6576 12.6439 8.41166 11.9061 9.14954L11.0461 10.0095H10.0869C7.97381 10.0095 6.26087 11.7225 6.26087 13.8355H9.0435V16.966C9.0435 17.4239 9.13581 17.86 9.30262 18.2573L8.34781 19.0529H6.9565V17.6616H5.56519V20.4442H11.8261V23.2269H10.4347V24.6182H13.2174V21.8355L14.4927 20.3051H17.5072L18.7826 21.8355V23.2269H17.3912V24.6182H22.9564V16.9659C22.9564 15.8134 23.8908 14.879 25.0434 14.879C25.073 14.879 25.1024 14.88 25.1317 14.8812C25.0741 14.6582 25.0434 14.4244 25.0434 14.1834C25.0435 12.6928 26.2156 11.476 27.6884 11.4042ZM20.1739 23.2268V20.305H20.2899L21.5652 21.8355V23.2268H20.1739Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagWales);
export default __webpack_public_path__ + "static/media/flag_wales.8dd516328c9644b642a381a9603ba70f.svg";
export { ForwardRef as ReactComponent };